<script setup lang="ts">
import { AccommodationSelector } from '@apps/main/new-desktop/modules/accommodationSelector';
import {
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';

import { AppMessageBox, AppRouterLink, AppSvgIcon } from '@libs/ui';

import type { ItineraryOwnStaySegment } from '../../../models/itinerarySegments/ownStay';
import ItineraryTimeline from '../ItineraryTimeline.vue';
import { useTripOverviewPageStore } from '../../../stores';

interface ItineraryOwnStaySegmentProps {
  segment: ItineraryOwnStaySegment;
}
const props = defineProps<ItineraryOwnStaySegmentProps>();

const statsigEventsStore = useStatsigEventsStore();
const tripOverviewPageStore = useTripOverviewPageStore();
const routerStore = useRouterStore();

function toggleAccommodation(): void {
  const isDisabled = true;
  statsigEventsStore.logTripOverviewHotelToggle(isDisabled);

  tripOverviewPageStore.addAccommodationToOwnStayIngredient(
    props.segment.context.ingredientId
  );
}
</script>

<template>
  <ItineraryTimeline
    :segment-type="props.segment.segmentType"
    class="itinerary-own-stay-segment"
  >
    <template #dropdown>
      <AccommodationSelector
        selected-option="noAccommodation"
        :disabled="false"
        class="accommodation-selector"
        @toggle-accommodation="toggleAccommodation"
      />
    </template>

    <template #content>
      <AppMessageBox
        :text="props.segment.addAccommodationMessage"
        message-type="primary"
      >
        <template #left-icon>
          <AppSvgIcon name="lightbulb" color="color-neutral-70" />
        </template>
        <template #link>
          <AppRouterLink
            :link="
              routerStore.getHotelSelectionUrl({
                ingredientIndex: props.segment.context.ingredientIndex,
              })
            "
            font="font-link-l-light"
            color="color-neutral-70"
            @capture-click="
              tripOverviewPageStore.addAccommodationToOwnStayIngredient(
                props.segment.context.ingredientId
              )
            "
          >
            <span class="link-text-own-stay">
              {{
                $t('planner.no_availability.actions.explore_hotels_selection')
              }}
            </span>
          </AppRouterLink>
        </template>
      </AppMessageBox>
    </template>
  </ItineraryTimeline>
</template>

<style scoped lang="scss">
.link-text-own-stay {
  text-decoration: underline;
}
</style>
